import { gql } from "@apollo/client"
import { useMemo } from "react"
import { QuotableCountry } from "@oysterhr/schema"
import { usePublicCostCalculatorQuery } from "./usePublicCostCalculatorQuery"

export const COUNTRY_LIST_QUERY = gql`
  query QuotableCountryList {
    quotableCountries {
      code
      name
      stateOrProvinces
    }
  }
`
export interface CountryFormDataResponse {
  quotableCountries: QuotableCountry[]
}

export const useQuotableCountries = () => {
  const { data, ...rest } =
    usePublicCostCalculatorQuery<CountryFormDataResponse>(COUNTRY_LIST_QUERY)

  const sortedUnsanctionedCountries = useMemo(
    () => data?.quotableCountries?.slice().sort((a, b) => (a.name < b.name ? -1 : 1)),
    [data],
  )

  /**
   * FIXME:
   * With the new version of Apollo, you can't modify the apollo data object, since it's read only.
   * This is a workaround to make the data mutable.
   */

  const returnData = data ? { ...data, quotableCountries: sortedUnsanctionedCountries ?? [] } : data

  return { data: returnData, ...rest }
}
